(function () {
  var root = document.querySelector('[data-shop-root]');
  var grid = document.querySelector('[data-grid]');
  if (!root || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
  var emptyMsg = grid.querySelector('[data-empty]');

  var state = { in: false, out: false, collections: [], sort: 'featured' };

  var products = cards.map(function (card) {
    var cols = (card.getAttribute('data-collections') || '')
      .split('||').filter(Boolean).map(function (pair) {
        var i = pair.indexOf('::');
        return { handle: pair.slice(0, i), title: pair.slice(i + 2) };
      });
    return {
      card: card,
      available: card.getAttribute('data-available') === '1',
      price: parseInt(card.getAttribute('data-price') || '0', 10),
      title: card.getAttribute('data-title') || '',
      collections: cols
    };
  });

  var catMap = {};
  products.forEach(function (p) {
    p.collections.forEach(function (c) {
      if (!catMap[c.handle]) catMap[c.handle] = { title: c.title, handle: c.handle, count: 0 };
      catMap[c.handle].count += 1;
    });
  });
  var categories = Object.keys(catMap).map(function (h) { return catMap[h]; })
    .sort(function (a, b) { return b.count - a.count || a.title.localeCompare(b.title); });

  var inCount = products.filter(function (p) { return p.available; }).length;
  var outCount = products.length - inCount;

  function renderCategoryRows(container) {
    if (!categories.length) return;
    container.innerHTML = categories.map(function (c) {
      return '<div class="flex items-center justify-between">' +
        '<button type="button" data-cat="' + c.handle + '" class="flex cursor-pointer items-center gap-2.5 text-left text-[13px] text-ink">' +
        '<span class="flex h-4 w-4 items-center justify-center rounded border border-line bg-white" data-check>' +
        '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" aria-hidden="true" class="hidden"><path d="M10 3 4.5 8.5 2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        c.title + '</button>' +
        '<span class="text-[13px] text-muted">(' + c.count + ')</span></div>';
    }).join('');
  }

  document.querySelectorAll('[data-filter-controls]').forEach(function (controls) {
    controls.querySelector('[data-count-in]').textContent = '(' + inCount + ')';
    controls.querySelector('[data-count-out]').textContent = '(' + outCount + ')';
    if (categories.length) {
      controls.querySelector('[data-category-group]').removeAttribute('hidden');
      renderCategoryRows(controls.querySelector('[data-category-rows]'));
    }
  });

  function setCheck(btn, on) {
    var box = btn.querySelector('[data-check]');
    var svg = box.querySelector('svg');
    if (on) {
      box.className = 'flex h-4 w-4 items-center justify-center rounded bg-primary text-white';
      svg.classList.remove('hidden');
    } else {
      box.className = 'flex h-4 w-4 items-center justify-center rounded border border-line bg-white';
      svg.classList.add('hidden');
    }
  }

  function syncControls() {
    document.querySelectorAll('[data-filter-controls]').forEach(function (controls) {
      controls.querySelectorAll('[data-avail]').forEach(function (btn) {
        setCheck(btn, btn.getAttribute('data-avail') === 'in' ? state.in : state.out);
      });
      controls.querySelectorAll('[data-cat]').forEach(function (btn) {
        setCheck(btn, state.collections.indexOf(btn.getAttribute('data-cat')) !== -1);
      });
    });
  }

  function renderChips() {
    var chips = [];
    if (state.in) chips.push({ key: 'av-in', label: 'In Stock' });
    if (state.out) chips.push({ key: 'av-out', label: 'Out of Stock' });
    state.collections.forEach(function (h) {
      chips.push({ key: 'col-' + h, label: (catMap[h] ? catMap[h].title : h) });
    });
    var box = root.querySelector('[data-chips]');
    box.innerHTML = chips.map(function (c) {
      return '<span class="inline-flex items-center gap-1.5 rounded-full border border-primary/20 bg-primary/[0.08] px-3 py-1.5 text-[13px] font-medium text-primary">' +
        c.label + '<button type="button" data-remove-chip="' + c.key + '" aria-label="Remove ' + c.label + ' filter" class="cursor-pointer leading-none">×</button></span>';
    }).join('');
    box.querySelectorAll('[data-remove-chip]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-remove-chip');
        if (key === 'av-in') state.in = false;
        else if (key === 'av-out') state.out = false;
        else if (key.indexOf('col-') === 0) toggleCollection(key.slice(4));
        apply();
      });
    });
    var count = chips.length;
    var badge = root.querySelector('[data-filter-count]');
    if (count > 0) { badge.textContent = count; badge.classList.remove('hidden'); badge.classList.add('flex'); }
    else { badge.classList.add('hidden'); badge.classList.remove('flex'); }
    document.querySelectorAll('[data-reset]').forEach(function (r) {
      if (state.in || state.out || state.collections.length) { r.classList.remove('hidden'); }
      else { r.classList.add('hidden'); }
    });
  }

  function apply() {
    var visible = products.filter(function (p) {
      if (state.in !== state.out) { if (state.in && !p.available) return false; if (state.out && p.available) return false; }
      if (state.collections.length) {
        var match = p.collections.some(function (c) { return state.collections.indexOf(c.handle) !== -1; });
        if (!match) return false;
      }
      return true;
    });

    if (state.sort === 'price-asc') visible.sort(function (a, b) { return a.price - b.price; });
    else if (state.sort === 'price-desc') visible.sort(function (a, b) { return b.price - a.price; });
    else if (state.sort === 'title-asc') visible.sort(function (a, b) { return a.title.localeCompare(b.title); });

    products.forEach(function (p) { p.card.style.display = 'none'; });
    visible.forEach(function (p) { p.card.style.display = ''; grid.insertBefore(p.card, emptyMsg); });
    if (emptyMsg) emptyMsg.classList.toggle('hidden', visible.length !== 0);

    var pc = document.querySelector('[data-product-count]');
    if (pc) pc.textContent = visible.length + ' ' + (visible.length === 1 ? 'product' : 'products');

    syncControls();
    renderChips();
  }

  function toggleCollection(handle) {
    var i = state.collections.indexOf(handle);
    if (i === -1) state.collections.push(handle); else state.collections.splice(i, 1);
  }

  document.addEventListener('click', function (e) {
    var avail = e.target.closest('[data-avail]');
    if (avail) { if (avail.getAttribute('data-avail') === 'in') state.in = !state.in; else state.out = !state.out; apply(); return; }
    var cat = e.target.closest('[data-cat]');
    if (cat) { toggleCollection(cat.getAttribute('data-cat')); apply(); return; }
    var reset = e.target.closest('[data-reset]');
    if (reset) { state.in = false; state.out = false; state.collections = []; apply(); return; }
  });

  var sortToggle = root.querySelector('[data-sort-toggle]');
  var sortMenu = root.querySelector('[data-sort-menu]');
  var sortLabel = root.querySelector('[data-sort-label]');
  var sortCaret = root.querySelector('[data-sort-caret]');
  sortToggle.addEventListener('click', function (e) { e.stopPropagation(); sortMenu.classList.toggle('hidden'); sortCaret.classList.toggle('rotate-180'); });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-sort]')) { sortMenu.classList.add('hidden'); sortCaret.classList.remove('rotate-180'); } });
  sortMenu.querySelectorAll('[data-sort-value]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.sort = btn.getAttribute('data-sort-value');
      sortLabel.textContent = btn.textContent.trim();
      sortMenu.querySelectorAll('[data-sort-value]').forEach(function (b) { b.className = 'flex w-full cursor-pointer items-center justify-between px-3 py-2 text-left text-[13px] text-ink transition-colors hover:bg-softer'; });
      btn.className = 'flex w-full cursor-pointer items-center justify-between px-3 py-2 text-left text-[13px] font-semibold text-primary transition-colors hover:bg-softer';
      sortMenu.classList.add('hidden');
      sortCaret.classList.remove('rotate-180');
      apply();
    });
  });

  var drawer = document.querySelector('[data-drawer]');
  root.querySelector('[data-open-filters]').addEventListener('click', function () {
    if (window.matchMedia('(max-width: 1023px)').matches && drawer) drawer.classList.remove('hidden');
  });
  if (drawer) {
    drawer.querySelector('[data-drawer-overlay]').addEventListener('click', function () { drawer.classList.add('hidden'); });
    drawer.querySelector('[data-drawer-close]').addEventListener('click', function () { drawer.classList.add('hidden'); });
  }

  apply();
})();
